import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BorderDirective } from "./border.directive";
import { InvalidControlScrollDirective } from "./invalid-control-scroll.directive";
import { KeyvaluePipe } from "../views/super-admin/views/app-teachers/pipes/keyvaluepip.pip";
import { ConfirmDialogComponent } from "./components/confirm-dialog/confirm-dialog.component";
import { NotificationPermissionDialogComponent } from "./components/notification-permission-dialog/notification-permission-dialog.component";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  declarations: [
    BorderDirective,
    InvalidControlScrollDirective,
    KeyvaluePipe,
    ConfirmDialogComponent,
    NotificationPermissionDialogComponent,
  ],
  exports: [
    BorderDirective,
    InvalidControlScrollDirective,
    KeyvaluePipe,
    ConfirmDialogComponent,
    NotificationPermissionDialogComponent,
  ],
})
export class SharedModule {}
